//TODO: Remove the unused interfaces after hooking up with backend data

enum ModalForm {
    ADD_DRIVERLOADNOTE = 'addNote',
    EDIT_DRIVERLOADNOTE = 'editNote',
    EMPTY = '',
}

export interface Option {
    id: number | string;
    name: string | number;
    disabled?: boolean;
}

export { ModalForm };
